import ApiService from '@/core/connector/api.service';
import TracksServices from '@/modules/contract/services/tracks.services';

export default class ContractServices extends ApiService {
  constructor(props) {
    super(props);
    this.url = 'sg';
  }

  async retrieve(id) {
    this.url = `${this.url}/documents/document_by_unique_id/${id}`;
    const { result: { data } } = await this.get();
    return data;
  }

  async sign(id, payload) {
    this.url = `${this.url}/document_contacts/signing/${id}`;
    this.payload = payload;
    const { result: { data } } = await this.postFile();
    return data;
  }

  async takeAction(id, type, payload = {}) {
    try {
      const infos = await new TracksServices().fetch();

      this.payload = { infos, ...payload };
      this.url = `${this.url}/document_contacts/${type}/${id}`;
      return await this.post();
    } catch (e) {
      this.__exit();
      throw e;
    }
  }

  async fetchSettings(type = 'term') {
    this.url = `${this.url}/settings/${type}`;
    const { result: { data } } = await this.get();
    return data;
  }
}
